const RateZeroIcon = ({ className = '' }) => (
  <svg
    width='56'
    height='56'
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='28' cy='28' r='28' fill='white' />
    <path
      d='M36.806 28.8172C36.8375 28.8487 36.8375 28.8995 36.806 28.931C36.7745 28.9625 36.7238 28.9625 36.6923 28.931C36.6608 28.8995 36.6608 28.8487 36.6923 28.8172C36.7238 28.7857 36.7763 28.7875 36.806 28.8172'
      stroke='#0FD08B'
      strokeWidth='2.625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M32.6585 20.0865C33.0278 19.2973 33.25 18.4275 33.25 17.5C33.25 14.1173 30.5078 11.375 27.125 11.375C23.7423 11.375 21 14.1173 21 17.5C21 18.5903 21.308 19.6 21.8085 20.4855'
      stroke='#0FD08B'
      strokeWidth='2.625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.004 25.375C10.1833 25.8528 9.625 26.733 9.625 27.7515C9.625 29.2758 10.8605 30.5112 12.3848 30.5112H14'
      stroke='#0FD08B'
      strokeWidth='2.625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.375 18.375V22.8445C40.6315 23.9785 41.629 25.3925 42.2205 27.0113H43.75C44.716 27.0113 45.5 27.7953 45.5 28.7613V34.125C45.5 35.091 44.716 35.875 43.75 35.875H41.4558C40.537 37.464 39.2105 38.787 37.625 39.7093V42.875C37.625 43.841 36.841 44.625 35.875 44.625H32.375C31.409 44.625 30.625 43.841 30.625 42.875V41.125H24.5V42.644C24.5 43.61 23.716 44.394 22.75 44.394H19.25C18.284 44.394 17.5 43.61 17.5 42.644V38.4353C15.3563 36.512 14 33.7313 14 30.625C14 24.8255 18.7005 20.125 24.5 20.125H32.4205C33.1713 20.125 33.8993 19.8783 34.4978 19.4268C35.371 18.7688 36.449 18.375 37.625 18.375H39.375V18.375Z'
      stroke='#0FD08B'
      strokeWidth='2.625'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='48.5'
      cy='50.5'
      r='4'
      stroke='#0FD08B'
      strokeDasharray='1.8 1.8'
    />
    <circle
      cx='8.5'
      cy='8.5'
      r='4.88889'
      stroke='#0FD08B'
      strokeWidth='1.22222'
      strokeDasharray='2.2 2.2'
    />
    <path
      d='M6 44L6.84853 47.1515L10 48L6.84853 48.8485L6 52L5.15147 48.8485L2 48L5.15147 47.1515L6 44Z'
      fill='#0FD08B'
    />
    <path
      d='M47 2L48.2728 6.72721L53 8L48.2728 9.27279L47 14L45.7272 9.27279L41 8L45.7272 6.72721L47 2Z'
      fill='#0FD08B'
    />
  </svg>
)

export default RateZeroIcon
